import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import "./footer.scss";
import { useState } from "react";
import { useSubscriberMutation } from "../../features/api/subscribersApiSlice";
import LoadingSpinner from "../loader/Loader";
import { useVideo } from "../../hooks/useVideo";

const Footer = () => {
  const { scrollToTop } = useVideo();
  const [email, setEmail] = useState("");
  const [subscribe, { isLoading }] = useSubscriberMutation(); // Get the mutation function and state

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email address.");
      return;
    }

    try {
      // Use the mutation function to make the API call
      const res = await subscribe({ email }).unwrap();
      toast.success(res?.message || "Subscription successful!");
      scrollToTop();
      setEmail("");
    } catch (err) {
      const errorMessage =
        err?.data?.message || "An error occurred. Please try again.";
      toast.error(errorMessage);
    }
  };

  if (isLoading) return <LoadingSpinner />;
  return (
    <div className="footer_container">
      <footer className="site-footer">
        <div className="footer-content">
          {/* About Section */}
          <div className="footer-section about-us">
            <h3>About eNotes Unlimited</h3>
            <p>
              eNotes Unlimited offers a wide range of woodworking
              tutorials, expert tips, and exclusive video content for
              woodworkers of all skill levels.
            </p>
          </div>

          {/* Navigation Links */}
          <div className="footer-section quick-links">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/faq">Faqs</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Subscribe Form */}
          <div className="footer-section subscribe-form">
            <h3>Subscribe to Our Newsletter</h3>
            <p>Get notified when eNotes add a new video</p>
            <form onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit">Subscribe</button>
            </form>
          </div>

          {/* Social Media Links */}
          <div className="footer-section social-media">
            <h3>Follow Us</h3>
            <div className="social-icons">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagramSquare />
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IoLogoYoutube />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="legal-links">
            <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
            <Link to="/terms-of-use">Terms of Use</Link> |{" "}
            <Link to="/cookie-policy">Cookie Policy</Link>
          </p>
          <p className="copyright">
            Copyright &copy; {new Date().getFullYear()} enotesunlimited.
            All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
